import { defineComponent as _defineComponent } from 'vue'
import { computed } from 'vue';
import useI18n from '@/mixins/useI18n';
import BCXMarkdown from '@/components/molecules/BCXMarkdown.vue';
import IconMyProjects from '@/components/svg/my-projects.svg?inline';
import useUserProjectCount from '@/mixins/useUserProjectCount';
import useUser from '@/mixins/useUser';
import { useRoute } from 'vue2-helpers/vue-router';


export default /*#__PURE__*/_defineComponent({
  __name: 'MyProjectsIntro',
  setup(__props) {

const { tc } = useI18n();
const { tUserFallback: t, isGuest } = useUser('self');
const route = useRoute();

const { remainingProjectsCount, hasProjectCount, loadRemainingProjectsCount } = useUserProjectCount();
loadRemainingProjectsCount();

const introMessage = computed(() => {
  let text = '';
  if (isGuest.value) {
    text = t('my-projects.intro_USERTYPE');
  }
  return text;
});

const freeProjectsMessage = computed(() => {
  let text = '';
  if (hasProjectCount.value && !isGuest.value) {
    const projects = `${tc('my-projects.projects_plural', remainingProjectsCount.value)}`;
    text = `\n${t('my-projects.introFreeProjects', { maxProjects: remainingProjectsCount.value, projects })}`;
  }
  return text;
});

return { __sfc: true,tc, t, isGuest, route, remainingProjectsCount, hasProjectCount, loadRemainingProjectsCount, introMessage, freeProjectsMessage, BCXMarkdown, IconMyProjects }
}

})